import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface Ruler {
  id: string;
  startPoint: { x: number; y: number; z: number };
  endPoint: { x: number; y: number; z: number };
  distanceInFeet: number;
}

export interface RulerState extends EntityState<Ruler> {
  selectedRulerId: string | null;
}

export const rulerAdapter: EntityAdapter<Ruler> = createEntityAdapter<Ruler>();

export const rulerInitialState: RulerState = rulerAdapter.getInitialState({
  selectedRulerId: null,
});
